/* eslint-disable */
import axios from "axios";
import store from '@/store/index'

axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/v1` ;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const Token = window.getCookie('x-pulse-token');
if( Token ) axios.defaults.headers.common["x-pulse-token"] = Token

axios.interceptors.request.use( config => {
	
	return config
}, error => Promise.reject(error));

axios.interceptors.response.use(config => {
	
	if( config.status === 222 ) {
		window.setCookie('x-pulse-token', null, 0) ;
		store.commit('user/setToken', null);
		location.href = '/'
	}
	if( config.data &&
		config.data.payload &&
		config.data.payload.token ) {
		axios.defaults.headers.common["x-pulse-token"] = config.data.payload.token
	}
	
	return config
	},
	error => Promise.reject(error)
);




export default axios